import { EnergyRating as JLDSEnergyRating } from "@JohnLewisPartnership/jl-design-system/dist/components/energy-rating/EnergyRating";
import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import classNames from "classnames";
import styles from "./EnergyRating.module.scss";
import {
  CardComponentProps,
  RatingLegacyValue,
  RatingValue,
} from "@~/types/types";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext.tsx";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";
import { useState } from "react";
import { EnergyDrawer } from "./components/EnergyDrawer";
import { ProductLink } from "../__shared__/ProductLink/ProductLink";

export function EnergyRating({
  configProps,
  product,
}: Pick<CardComponentProps, "configProps" | "product">) {
  const { variant } = useVariant();
  const dispatchCardEvent = useProductCardEvent();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [altText, setAltText] = useState<string | undefined>(undefined);

  if (!variant?.energy) {
    return null;
  }

  const { rating } = variant.energy;
  const { hideEnergySideDrawer } = configProps || {};
  const energyRating = (
    <JLDSEnergyRating
      className={classNames(styles.energyRating, {
        [styles.legacy!]: rating.legacy,
        [styles.energyRating__large!]: configProps?.size === "large",
      })}
      rating={rating.legacy ? undefined : (rating.value as RatingValue)}
      ratingLegacy={
        rating.legacy ? (rating.value as RatingLegacyValue) : undefined
      }
      hasEnergySideDrawer={!hideEnergySideDrawer}
      handleEnergyRatingClick={(alt) => {
        setAltText(alt);
        setDrawerOpen(true);
        dispatchCardEvent(productCardEvents.energyRatingClicked);
      }}
    />
  );

  return (
    <div data-component="pcl-EnergyRating">
      {hideEnergySideDrawer ? (
        <ProductLink product={product} componentName="EnergyRating">
          {energyRating}
        </ProductLink>
      ) : (
        energyRating
      )}
      <EnergyDrawer
        handleClose={() => setDrawerOpen(false)}
        isOpen={drawerOpen}
        energy={variant.energy}
        altText={altText}
      />
    </div>
  );
}
